import { Component, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { StaticPageService } from '../../../shared/services/static-page.service';
import {
  AnalisisResponse,
  UnidadAnalisis,
} from '../../../shared/models/static-model/analisis.model';
import { TableGeneralSimpleComponent } from '../../../shared/components-generals/table-general-simple/table-general-simple.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  imports: [TableGeneralSimpleComponent, CommonModule, TranslateModule],
})
export class AnalysisComponent {
  public URL_API = environment.apiURLNew;
  public load = false;
  public headers: { value: string; description: string }[] = [];
  public dataSource = new MatTableDataSource<any>([]);
  public miG_UNIDAD_ANALISIS: UnidadAnalisis | null = null;
  public miG_BURO_ANALISIS: any[] = [];
  public miG_COMMENTS_ANALISIS: any | null = null;
  @Input() quotationId = 0;

  constructor(private staticPageService: StaticPageService) {}

  ngOnInit(): void {
    this.getTable();
  }

  public getTable(): void {
    this.load = true;
    this.staticPageService
      .getAnalisis(this.quotationId)
      .subscribe((ress: AnalisisResponse | null) => {
        this.load = false;
        if (!ress) return;
        this.dataSource.data = ress.miG_DOCS_ANALISIS.map((doc: any) => {
          return {
            Documento: doc.idCaratula,
            tipo: doc.tipo,
            nombreCompleto: doc.nombreCompleto,
            descDocumento: doc.descDocumento,
          };
        });
        this.headers = Object.keys(this.dataSource.data[0]).map((key) => ({
          value: key,
          description: key,
        }));
        this.miG_UNIDAD_ANALISIS = ress!.miG_UNIDAD_ANALISIS;
      });
  }

  // public openModalHeaderTable(): void {
  //   // this.tableGeneralComponent.openModalHeaderTable();
  // }

  public activityfuntion(id: string | number): void {}
}
